import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import MaterialSpinner from "../../../../ui/materialSpinner";
import GroheFeatureButtons from "./groheFeatureButtons";
import GroheFeatureContent from "./groheFeatureContent";
import GroheFeatureContentInCart from "./groheFeatureContentInCart";

import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import GroheFeatureTopButtons from "./groheFeatureTopButtons";
import {useViewItemAnalyticsEvent} from "../../../hocs/analyticsEventHooks";

const GroheFeature = (props) => {

  const {lookActiveFeature, selection, showAddedToTheCartSuccess, wizardActiveItem, fabricatorSettings} = props;

  useViewItemAnalyticsEvent(lookActiveFeature, wizardActiveItem, fabricatorSettings);

  if (!lookActiveFeature || wizardActiveItem) {
    if (selection) {
      return <MaterialSpinner/>
    }
    return null
  }

  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);

  return (
    <div className={"lk-feature grohe-feature" + (featureIsLocked ? " grohe-feature--locked" : "")}>
      <div className="lk-feature__main grohe-feature__main">
        <GroheFeatureTopButtons/>
        <LookFeatureImage/>
        {showAddedToTheCartSuccess ? <GroheFeatureContentInCart/> : <GroheFeatureContent/>}
        <GroheFeatureButtons/>
      </div>
    </div>
  )
};

GroheFeature.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {showAddedToTheCartSuccess} = store.groheState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {wizardActiveItem} = store.wizardState;
  const {settings} = store.fabricatorState;

  return {
    lookActiveFeature,
    showAddedToTheCartSuccess,
    isPhoneNumberValidated,
    wizardActiveItem,
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(GroheFeature)
